"use client";

import { Card, CardBody, Progress } from "@heroui/react";
import Image from "next/image";
import Badge from "@/components/badge";

type TagLevel = "iniciante" | "intermediario" | "maximo" | "ametista";

interface LevelAtual {
  nivel: number;
  titulo: string;
  tag: TagLevel;
  xp_max: number;
  xp_min: number;
}

interface ProfileCardProps {
  userImage?: string | null;
  userNome?: string | null;
  cursoNome: string;
  poloNome?: string;
  levelAtual?: LevelAtual;
  xpTotal: number;
}

export default function ProfileCard({ userImage, userNome, cursoNome, poloNome = "", levelAtual, xpTotal }: ProfileCardProps) {
  const handleProgressColor = () => {
    if (!levelAtual) return "default" as const;

    if (levelAtual.tag === "iniciante") return "success";
    if (levelAtual.tag === "intermediario") return "primary";
    if (levelAtual.tag === "maximo") return "warning";
    if (levelAtual.tag === "ametista") return "secondary";

    return "default" as const;
  };

  return (
    <Card className="backdrop-blur-lg bg-white/10 w-full p-4 md:p-6">
      <CardBody className="flex flex-col gap-8 md:flex-row md:items-center md:justify-between">
        {/* Imagem + nome */}
        <div className="flex flex-col items-center md:flex-row md:items-center gap-6 md:gap-8 w-full md:w-2/3">
          <Image
            className="object-cover rounded-full border shadow aspect-square w-24 h-24 md:w-32 md:h-32"
            quality={100}
            width={200}
            height={200}
            src={userImage || "/defaultUser.jpg"}
            alt="Foto de perfil"
          />

          <div className="flex flex-col items-center md:items-start text-center md:text-left gap-2">
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-2 md:gap-3">
              <h1 className="font-bold text-2xl md:text-3xl">{userNome}</h1>
              {levelAtual && <Badge label={levelAtual.titulo} level={levelAtual.tag} />}
            </div>

            <p className="font-light text-gray-400">
              {cursoNome} • UNIVC {poloNome && <>• {poloNome}</>}
            </p>
          </div>
        </div>

        {/* Experiência */}
        {levelAtual && (
          <div className="flex flex-col gap-2 w-full md:w-1/3">
            <div className="w-full flex justify-between items-end">
              <h1 className="text-2xl font-bold text-center md:text-left">Nivel: {levelAtual.nivel}</h1>
              <p className="font-light text-gray-400">
                {xpTotal}/{levelAtual.xp_max}
              </p>
            </div>
            <Progress isStriped value={xpTotal} minValue={levelAtual.xp_min} maxValue={levelAtual.xp_max} color={handleProgressColor()} className="w-full" />
          </div>
        )}
      </CardBody>
    </Card>
  );
}
